import { SHOW_LISTING_RATINGS_COPY } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.keys";
import { SIDEBAR_KEYS, TEMPLATE_KEYS } from "../../constants";

export const INITIAL_VALUES = {
  teams: "Teams",
  nav_teams: "Teams in Nav",
};

export const form_data = {
  sku: "sku",
  keyword: "keyword",
  plan: "plan",
  listings: "listings",
};

// Misc-data keys of the offerings section payload (the inner `data` object of
// the OFFERING_SECTION row). Shared by the sidebar form, the Save payload and
// the live iframe preview push.
export const OFFERINGS_SECTION_DATA_KEYS = {
  SHOW_RATINGS: "show_ratings",
};

export const SHOW_RATINGS_MISC_KEY = OFFERINGS_SECTION_DATA_KEYS.SHOW_RATINGS;

export const UPDATE_NAME_TEXTS = {
  SAVE: "Save",
  SAVING: "...",
  CANCEL: "Cancel",
};

export const SOCIAL_INFO_KEYS = {
  ROOT: "social_info",
  WEBSITE_DESC: "website_desc",
  ABOUT_SECTION_TITLE: "about_section_title",
  EXPERIENCE_YEARS_COUNT: "experience_years_count",
  EXPERIENCE_YEARS_LABEL: "experience_years_label",
  VIDEO: "video",
  LOGO_TEXT: "logo_text",
  LOGO_IMAGE: "logo_image",
  WEBSITE_HEADING: "website_heading",
  MOBILE_COVER_IMAGE: "mobile_cover_image",
  INTEREST_CTA_TEXT: "interest_cta_text",
  INTEREST_HELPER_TEXT: "interest_helper_text",
};

export const LEAD_KEYS = {
  ROOT: "lead_keys",
  ABOUT_TITLE: "about_title",
  OFFERINGS_TITLE: "offerings_title",
  OFFERINGS_SECTION_TITLE: "offerings_section_title",
  ABOUT_SECTION_NAVBAR_TITLE: "about_section_navbar_title",
  EXPAND_HOST_DESC: "expand_host_desc",
  CUSTOM_TEAM_NAVBAR_TITLE: "custom_team_navbar_title",
  CUSTOM_TEAM_SECTION_TITLE: "custom_team_section_title",
};

export const TEAMS_DATA_KEYS = {
  SECTION_TITLE: LEAD_KEYS.CUSTOM_TEAM_SECTION_TITLE,
  NAVBAR_TITLE: LEAD_KEYS.CUSTOM_TEAM_NAVBAR_TITLE,
};

export const COVER_IMAGE_KEY = "cover_image";

export const ABOUT_YOU_RAW_KEYS = {
  DISPLAY_IMAGE: "display_image",
  DISPLAY_NAME: "display_name",
  BIO_TEXT: "bio_text",
  NAVBAR_TITLE: "navbar_title",
};

export const HEADER_SECTION_TEXTS = {
  LOGO_TEXT_LABEL: "Logo text",
  LOGO_IMAGE_LABEL: "Website logo image",
  ABOUT_TITLE_LABEL: "About Title",
  OFFERINGS_TITLE_LABEL: "Offerings Title",
  TEAM_TITLE_LABEL: "Team Title",
  DIVIDER_OR: "OR",
  INFO_LOGO: "Logo Text will only be shown if no Logo Image is set.",
  INFO_DEFAULT:
    "If none of these is set, the Page Title will be used by default.",
  REMOVE_LOGO_BTN: "Remove Logo",
  HOVER_TEXT: "Upload Image",
  LOGO_QUERY: "logo",
  ERROR_LOGO_TEXT_LENGTH: (current) =>
    `Logo text must be under 50 characters (Currently ${current})`,
  ERROR_ABOUT_TITLE_LENGTH: (current) =>
    `About text must be under 30 characters (Currently ${current})`,
  ERROR_OFFERINGS_TITLE_LENGTH: (current) =>
    `Offerings text must be under 30 characters (Currently ${current})`,
  ERROR_TEAM_TITLE_LENGTH: (current) =>
    `Team text must be under 30 characters (Currently ${current})`,
};

export const HEADER_SECTION_FIELDS = {
  LOGO_TEXT: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.LOGO_TEXT],
  LOGO_IMAGE: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.LOGO_IMAGE],
  ABOUT_TITLE: [LEAD_KEYS.ROOT, LEAD_KEYS.ABOUT_TITLE],
  OFFERINGS_TITLE: [LEAD_KEYS.ROOT, LEAD_KEYS.OFFERINGS_TITLE],
  TEAM_NAVBAR_TITLE: [LEAD_KEYS.ROOT, TEAMS_DATA_KEYS.NAVBAR_TITLE],
  ERROR_KEY_LOGO_TEXT: SOCIAL_INFO_KEYS.LOGO_TEXT,
  ERROR_KEY_ABOUT_TITLE: LEAD_KEYS.ABOUT_TITLE,
  ERROR_KEY_OFFERINGS_TITLE: LEAD_KEYS.OFFERINGS_TITLE,
  ERROR_KEY_TEAM_NAVBAR_TITLE: TEAMS_DATA_KEYS.NAVBAR_TITLE,
};

export const HEADER_SECTION_LIMITS = {
  MAX_LOGO_TEXT_LENGTH: 50,
  MAX_ABOUT_TITLE_LENGTH: 30,
  MAX_OFFERINGS_TITLE_LENGTH: 30,
  MAX_TEAM_TITLE_LENGTH: 30,
  LOGO_IMAGE_FULL_WIDTH: 250,
  LOGO_IMAGE_WIDTH: 250,
  LOGO_IMAGE_HEIGHT: 60,
};

export const COVER_SECTION_TEXTS = {
  COVER_IMAGE: COVER_IMAGE_KEY,
  WEBSITE_HEADING: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.WEBSITE_HEADING],
  WEBSITE_DESC: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.WEBSITE_DESC],
  MOBILE_COVER_IMAGE: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.MOBILE_COVER_IMAGE,
  ],
  INTEREST_CTA_TEXT: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.INTEREST_CTA_TEXT,
  ],
  INTEREST_HELPER_TEXT: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.INTEREST_HELPER_TEXT,
  ],
  ERROR_KEY_WEBSITE_HEADING: SOCIAL_INFO_KEYS.WEBSITE_HEADING,
  ERROR_KEY_WEBSITE_DESC: SOCIAL_INFO_KEYS.WEBSITE_DESC,
  ERROR_KEY_INTEREST_CTA_TEXT: SOCIAL_INFO_KEYS.INTEREST_CTA_TEXT,
  ERROR_KEY_INTEREST_HELPER_TEXT: SOCIAL_INFO_KEYS.INTEREST_HELPER_TEXT,
  DEFAULT_COVER_IMAGE_LABEL: "Default cover image",
  MOBILE_COVER_IMAGE_LABEL: "Cover image for Mobile (Optional)",
  PAGE_TITLE_LABEL: "Page title",
  SHORT_BIO_LABEL: "Short bio",
  GO_TO_OFFERINGS_LABEL: "Go to offerings button",
  GET_IN_TOUCH_HEADER_LABEL: "Get in touch header text",
  GET_IN_TOUCH_BTN_LABEL: "Get In Touch button text",
  MOBILE_COVER_IMAGE_TOOLTIP:
    "Add this image for mobile to avoid cropping. If not added, the default cover image will be used",
  GO_TO_OFFERINGS_TOOLTIP:
    "This button will scroll down the visitor straight to your offerings section",
  HOVER_TEXT: "Upload Image",
  COVER_QUERY: "cover",
  RECOMMENDED_FORMAT_DEFAULT: (width, height) =>
    `Recommended format: ${width}\u00a0\u00d7\u00a0${height} pixels (PNG or JPG)`,
  RECOMMENDED_FORMAT_MOBILE:
    "Recommended format: 750\u00a0\u00d7\u00a01120 pixels (PNG or JPG)",
  INPUT_NAME_TITLE: "title",
  INPUT_NAME_SHORT_DESC: "short_description",
  INPUT_NAME_OFFERINGS_CTA: "offerings_cta_text",
  INPUT_NAME_INTEREST_HELPER: SOCIAL_INFO_KEYS.INTEREST_HELPER_TEXT,
  INPUT_NAME_INTEREST_CTA: SOCIAL_INFO_KEYS.INTEREST_CTA_TEXT,
  ERROR_MAX_LENGTH: (current, max) => `Maximum field length of ${max} reached.`,
  ERROR_MIN_BIO_LENGTH: (min) => `Short bio must be at least ${min} characters`,
  ERROR_OFFERINGS_CTA_LENGTH: (current) =>
    `Go to offerings button text must be under 30 characters(Currently ${current})`,
  ID_WEBSITE_COVER: "website_cover_mypage",
  ID_MOBILE_COVER: "website_mobile_cover_mypage",
  MODERN_SLUG: "modern",
};

export const COVER_SECTION_FIELDS = {
  COVER_IMAGE: COVER_IMAGE_KEY,
  WEBSITE_HEADING: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.WEBSITE_HEADING],
  WEBSITE_DESC: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.WEBSITE_DESC],
  MOBILE_COVER_IMAGE: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.MOBILE_COVER_IMAGE,
  ],
  INTEREST_CTA_TEXT: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.INTEREST_CTA_TEXT,
  ],
  INTEREST_HELPER_TEXT: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.INTEREST_HELPER_TEXT,
  ],
  ERROR_KEY_WEBSITE_HEADING: SOCIAL_INFO_KEYS.WEBSITE_HEADING,
  ERROR_KEY_WEBSITE_DESC: SOCIAL_INFO_KEYS.WEBSITE_DESC,
  ERROR_KEY_INTEREST_CTA_TEXT: SOCIAL_INFO_KEYS.INTEREST_CTA_TEXT,
  ERROR_KEY_INTEREST_HELPER_TEXT: SOCIAL_INFO_KEYS.INTEREST_HELPER_TEXT,
};

export const DEFAULT_TEXT_OFFERINGS = "Offerings in Navbar";
export const DEFAULT_TEXT_TEAMS = "Teams in Navbar";
export const DEFAULT_TEXT_ABOUT_YOU = "About You in Navbar";

export const ABOUT_YOU_LABELS = {
  DISPLAY_PICTURE: "Display Picture",
  UPLOAD_DISPLAY_IMAGE: "Upload Display Image",
  YOUR_NAME: "Your Name",
  SHORT_BIO: "Short bio",
  SECTION_TITLE: "What would you like to call this section?",
  NAVBAR_TITLE: "What would you like to call this section in Navbar?",
  ABOUT_YOU: "About You",
  READ_MORE_CLOSED: "Keep description expanded by default",
  EXPERIENCE_YEARS: "Number of Years of Experience",
  EXPERIENCE_LABEL: "Label for Years of Experience",
  INTRO_VIDEO: "Intro Video link (eg: Youtube Video)",
  HOW_TO_UPLOAD: "How to upload?",
};

export const ABOUT_YOU_PLACEHOLDERS = {
  KEEP_SHORT: "Keep it short",
  EXPERIENCE_EXAMPLE: "eg: years of experience",
};

export const ABOUT_YOU_MESSAGES = {
  MAX_FIELD_LENGTH: "Maximum field length of",
  REACHED: "reached.",
  NAME_REQUIRED: "A name is required",
  FULL_NAME_MIN: "Full name must be at least",
  CHARACTERS: "characters",
  CURRENTLY: "Currently",
  SHORT_BIO_MIN: "Short bio must be at least",
  INVALID_VIDEO_URL: "Invalid Video URL",
  VIDEO_HELP_TEXT:
    "A video is not compulsory but it helps drive higher purchases.",
  EXPERIENCE_BOX_INFO:
    "The experience box is shown here on the page for preview.\nIf the experience fields below are left empty, the box will not be shown on the main page.",
  NAVBAR_TITLE_MAX: "Navbar title must be under",
};

export const ABOUT_YOU_DEFAULTS = {
  ABOUT_YOU: "About You",
  ABOUT: "About",
  IMAGE_QUERY: "profile",
  FONT_FAMILY: "Helvetica Neue",
};

export const ABOUT_YOU_DIMENSIONS = {
  IMAGE_FULL_WIDTH: 250,
  IMAGE_WIDTH: 100,
  IMAGE_HEIGHT: 100,
  IMAGE_BORDER_RADIUS: "100%",
};

export const ABOUT_YOU_LINKS = {
  YOUTUBE_UPLOAD_HELP:
    "https://support.google.com/youtube/answer/57407?co=GENIE.Platform%3DDesktop&hl=en",
};

export const ABOUT_YOU_FIELD_KEYS = {
  DISPLAY_IMAGE: ABOUT_YOU_RAW_KEYS.DISPLAY_IMAGE,
  DISPLAY_NAME: ABOUT_YOU_RAW_KEYS.DISPLAY_NAME,
  BIO_TEXT: ABOUT_YOU_RAW_KEYS.BIO_TEXT,
  SOCIAL_INFO_WEBSITE_DESC: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.WEBSITE_DESC,
  ],
  SOCIAL_INFO_ABOUT_SECTION_TITLE: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.ABOUT_SECTION_TITLE,
  ],
  SOCIAL_INFO_EXPERIENCE_YEARS_COUNT: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.EXPERIENCE_YEARS_COUNT,
  ],
  SOCIAL_INFO_EXPERIENCE_YEARS_LABEL: [
    SOCIAL_INFO_KEYS.ROOT,
    SOCIAL_INFO_KEYS.EXPERIENCE_YEARS_LABEL,
  ],
  SOCIAL_INFO_VIDEO: [SOCIAL_INFO_KEYS.ROOT, SOCIAL_INFO_KEYS.VIDEO],
  LEAD_KEYS: LEAD_KEYS.ROOT,
  LEAD_KEYS_ABOUT_TITLE: [LEAD_KEYS.ROOT, LEAD_KEYS.ABOUT_TITLE],
  LEAD_KEYS_ABOUT_SECTION_NAVBAR_TITLE: [
    LEAD_KEYS.ROOT,
    LEAD_KEYS.ABOUT_SECTION_NAVBAR_TITLE,
  ],
  LEAD_KEYS_EXPAND_HOST_DESC: [LEAD_KEYS.ROOT, LEAD_KEYS.EXPAND_HOST_DESC],
  NAVBAR_TITLE: ABOUT_YOU_RAW_KEYS.NAVBAR_TITLE,
  SECTION_TITLE: SOCIAL_INFO_KEYS.SECTION_TITLE,
};

export const ABOUT_YOU_ERROR_KEYS = {
  DISPLAY_NAME: ABOUT_YOU_RAW_KEYS.DISPLAY_NAME,
  WEBSITE_DESC: SOCIAL_INFO_KEYS.WEBSITE_DESC,
  VIDEO: SOCIAL_INFO_KEYS.VIDEO,
  ABOUT_TITLE: LEAD_KEYS.ABOUT_TITLE,
};

export const ABOUT_YOU_LEAD_KEY_FIELDS = {
  ABOUT_TITLE: LEAD_KEYS.ABOUT_TITLE,
  EXPAND_HOST_DESC: LEAD_KEYS.EXPAND_HOST_DESC,
};

export const OFFERINGS_SECTION_LABELS = {
  SECTION_TITLE: "What would you like to call this section?",
  NAVBAR_TITLE: "What would you like to call this section in Navbar?",
  SHOW_RATINGS: SHOW_LISTING_RATINGS_COPY.toggle_label,
  SAVE_BUTTON: "Save & next",
};

export const OFFERINGS_SECTION_PLACEHOLDERS = {
  HEADING: "Eg: Explore How can I help you",
  DESCRIPTION: "Tip: use this space to induce excitement for your offerings",
};

export const OFFERINGS_SECTION_MESSAGES = {
  ASSIGN_ERROR_LOG: "assign awards err",
  INVALID_FORM: "Invalid form values",
  NAVBAR_UPDATE_ERROR: "Navbar title update failed",
  NAVBAR_UPDATE_FAILED: "Failed to update navbar title",
  ERROR_LOCATION: "OfferingsSection.js - handleSave function",
  ERROR_WHEN: "Updating navbar title for offerings section",
  SHOW_RATINGS_ERROR_LOCATION: "OfferingsSection.js - show ratings toggle",
  SHOW_RATINGS_FETCH_WHEN:
    "Fetching show_listing_ratings account setting for offerings section",
  SHOW_RATINGS_UPDATE_WHEN:
    "Persisting show_listing_ratings account setting for offerings section",
};

export const OFFERINGS_SECTION_DEFAULTS = {
  SECTION_NAME: "Offerings",
  HEADING: "Pick a Course to get started",
  SECTION_NAME_KEY: "section_name",
  SOURCE: "exly",
  REQUEST_METHOD: "POST",
  TEXTAREA_ROWS: "4",
  TEXTAREA_MIN_WIDTH: "100%",
  NAV_SECTION_NAME_KEY: "nav_section_name",
};

export const OFFERINGS_SECTION_VALIDATION = {
  REQUIRED: "Required",
  ERROR_TYPE: "error",
};

export const OFFERINGS_SECTION_FIELD_NAMES = {
  SECTION_TITLE: "section_title",
  NAVBAR_TITLE: "navbar_title",
  HEADING: "heading",
  DESCRIPTION: "description",
};

export const OFFERINGS_SECTION_FIELD_KEYS = {
  SECTION_TITLE: [LEAD_KEYS.ROOT, LEAD_KEYS.OFFERINGS_SECTION_TITLE],
  NAVBAR_TITLE: [LEAD_KEYS.ROOT, LEAD_KEYS.OFFERINGS_TITLE],
};

export const OFFERINGS_SECTION_FORM_KEYS = {
  section_name: {
    key: OFFERINGS_SECTION_DEFAULTS.SECTION_NAME_KEY,
    label: OFFERINGS_SECTION_LABELS.SECTION_TITLE,
    field: OFFERINGS_SECTION_FIELD_KEYS.SECTION_TITLE,
    max_length: null,
  },
  nav_section_name: {
    key: OFFERINGS_SECTION_DEFAULTS.NAV_SECTION_NAME_KEY,
    label: OFFERINGS_SECTION_LABELS.NAVBAR_TITLE,
    field: OFFERINGS_SECTION_FIELD_KEYS.NAVBAR_TITLE,
    max_length: null,
  },
  heading: {
    key: "heading",
    label: "Heading",
    placeholder: OFFERINGS_SECTION_PLACEHOLDERS.HEADING,
    max_length: null,
  },
  description: {
    key: "description",
    label: "Description",
    placeholder: OFFERINGS_SECTION_PLACEHOLDERS.DESCRIPTION,
    max_length: null,
  },
};

export const TEAMS_FORM_DATA = {
  heading: {
    key: "heading",
    label: "Heading",
  },
  description: {
    key: "description",
    label: "Description",
  },
};

export const TEAMS_LABELS = {
  SECTION_TITLE: "What would you like to call this section?",
  NAVBAR_TITLE: "What would you like to call this section in Navbar?",
  SAVE_BUTTON: "Save & next",
};

export const TEAMS_PLACEHOLDERS = {
  HEADING: "Eg: Learn from our best",
  DESCRIPTION: "Tip: use this space to describe this section",
};

export const TEAMS_MESSAGES = {
  MAX_FIELD_LENGTH: "Maximum field length of",
  REACHED: "reached.",
  NAVBAR_UPDATE_ERROR: "Navbar title update failed",
  NAVBAR_UPDATE_FAILED: "Failed to update navbar title",
  NAVBAR_UPDATE_WHEN:
    "Updating navbar title for teams section in TemplatePreview",
  NAVBAR_UPDATE_LOCATION:
    "src/ui/pages/TemplatePreview/components/Sidebar/components/Teams.js - updateCreatorDataMutation.onError",
  SAVE_ERROR: "Error in saving teams data",
  SAVE_ERROR_WHEN: "Saving teams data in TemplatePreview",
  SAVE_ERROR_LOCATION:
    "src/ui/pages/TemplatePreview/components/Sidebar/components/Teams.js - handleSave",
  SAVE_SUCCESS: "Teams section saved successfully",
  SECTION_TITLE_UPDATE_ERROR: "Section title update failed",
  SECTION_TITLE_UPDATE_FAILED: "Failed to update section title",
  SECTION_TITLE_UPDATE_WHEN:
    "Updating section title for teams section in TemplatePreview",
  SECTION_TITLE_UPDATE_LOCATION:
    "src/ui/pages/TemplatePreview/components/Sidebar/components/Teams.js - updateSectionTitleMutation.onError",
};

export const TEAMS_DEFAULTS = {
  SOURCE: "exly",
  ERROR_TYPE: "error",
  TEXTAREA_ROWS: "4",
  TEXTAREA_MIN_WIDTH: "100%",
};

export const TEAMS_ERROR_KEYS = {
  SECTION_HEADING: "sectionHeading",
  SECTION_DESCRIPTION: "sectionDescription",
};

export const TEAMS_FIELD_KEYS = {
  SECTION_TITLE: [LEAD_KEYS.ROOT, TEAMS_DATA_KEYS.SECTION_TITLE],
  NAVBAR_TITLE: [LEAD_KEYS.ROOT, TEAMS_DATA_KEYS.NAVBAR_TITLE],
};

export const TEAMS_SECTION_FORM_KEYS = {
  section_name: {
    key: "section_name",
    label: TEAMS_LABELS.SECTION_TITLE,
    field: TEAMS_FIELD_KEYS.SECTION_TITLE,
    max_length: null,
  },
  nav_section_name: {
    key: "nav_section_name",
    label: TEAMS_LABELS.NAVBAR_TITLE,
    field: TEAMS_FIELD_KEYS.NAVBAR_TITLE,
    max_length: null,
  },
  heading: {
    key: "heading",
    label: "Heading",
    placeholder: TEAMS_PLACEHOLDERS.HEADING,
    max_length: null,
  },
  description: {
    key: "description",
    label: "Description",
    placeholder: TEAMS_PLACEHOLDERS.DESCRIPTION,
    max_length: null,
  },
};

export const SIDEBAR_HIDDEN_FIELDS_CONFIG = {
  [SIDEBAR_KEYS.OFFERINGS_SECTION]: [
    {
      templates: [
        TEMPLATE_KEYS.EDUVERSE,
        TEMPLATE_KEYS.YOGA,
        TEMPLATE_KEYS.GROWTH,
        TEMPLATE_KEYS.CLASSIC,
        TEMPLATE_KEYS.MODERN,
        TEMPLATE_KEYS.ELEMENTARY,
      ],
      fields: [
        OFFERINGS_SECTION_FIELD_NAMES.HEADING,
        OFFERINGS_SECTION_FIELD_NAMES.DESCRIPTION,
      ],
    },
    {
      templates: [
        TEMPLATE_KEYS.YOGA,
        TEMPLATE_KEYS.GROWTH,
        TEMPLATE_KEYS.CLASSIC,
        TEMPLATE_KEYS.MODERN,
        TEMPLATE_KEYS.ELEMENTARY,
        TEMPLATE_KEYS.EDUVERSE,
      ],
      fields: [OFFERINGS_SECTION_FIELD_NAMES.SECTION_TITLE],
    },
    {
      templates: [TEMPLATE_KEYS.UNFOLD],
      fields: [OFFERINGS_SECTION_FIELD_NAMES.DESCRIPTION],
    },
  ],
  [SIDEBAR_KEYS.ABOUT_YOU]: [
    {
      templates: [
        TEMPLATE_KEYS.UNFOLD,
        TEMPLATE_KEYS.LINKTEMP,
        TEMPLATE_KEYS.ELEMENTARY,
      ],
      fields: [ABOUT_YOU_FIELD_KEYS.NAVBAR_TITLE],
    },
    {
      templates: [TEMPLATE_KEYS.ELEMENTARY],
      fields: [ABOUT_YOU_FIELD_KEYS.SECTION_TITLE],
    },
  ],
};
